import React from "react";
import { motion } from "framer-motion";
import { UploadCloud, Wrench, PackageCheck, Palette, Truck, MessageCircle } from "lucide-react";
import SectionAccents from "@/components/SectionAccents";

const STEPS = [
    { icon: UploadCloud, title: "1 · Pick & upload", desc: "Choose your product, size, and upload reference photos (front, side, back).", color: "from-brand-peach to-brand-coral" },
    { icon: MessageCircle, title: "2 · Consult on WhatsApp", desc: "Our team confirms the design details, pose, outfit and any engraving over a friendly chat.", color: "from-brand-lavender to-primary/30" },
    { icon: Wrench, title: "3 · Sculpt & approve", desc: "Our artists sculpt the base miniature and share progress shots for your approval.", color: "from-brand-mint to-brand-sky" },
    { icon: Palette, title: "4 · Handcraft & paint", desc: "Our artisans hand-paint every miniature with premium acrylics to match your reference.", color: "from-brand-gold/80 to-brand-peach" },
    { icon: PackageCheck, title: "5 · Quality & package", desc: "Every miniature passes multi-step QC, then is packed in our signature gift box.", color: "from-brand-sky to-brand-lavender" },
    { icon: Truck, title: "6 · Doorstep delight", desc: "Track your order live from sculpting to delivery, right to your doorstep.", color: "from-primary/40 to-brand-gold/60" },
];

const HowItWorks = () => (
    <div className="relative max-w-7xl mx-auto px-6 py-16 overflow-hidden" data-testid="how-it-works-page">
        <SectionAccents variant="howitworks" />
        <div className="text-center max-w-2xl mx-auto">
            <div className="text-xs uppercase tracking-widest text-brand-gold font-semibold">Behind the magic</div>
            <h1 className="font-display text-5xl md:text-6xl font-bold tracking-tighter mt-1">How Cherishables works</h1>
            <p className="text-muted-foreground mt-4">A 6-step journey from photo to hand-painted keepsake — with delightful moments every step of the way.</p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {STEPS.map((s, i) => (
                <motion.div
                    key={s.title}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.06 }}
                    className={`rounded-4xl p-6 md:p-8 relative overflow-hidden bg-gradient-to-br ${s.color}/40 border border-white/50`}
                >
                    <div className="w-14 h-14 rounded-2xl bg-white/70 flex items-center justify-center mb-4 text-primary shadow-sm">
                        <s.icon className="w-6 h-6" />
                    </div>
                    <h3 className="font-display text-xl md:text-2xl font-semibold">{s.title}</h3>
                    <p className="text-sm text-foreground/70 mt-2">{s.desc}</p>
                </motion.div>
            ))}
        </div>
    </div>
);

export default HowItWorks;
